import UserApiKeyPagingResultModelBase from '../_generated/modelBases/user-api-key-paging-result-model-base';

export default class UserApiKeyPagingResultModel extends UserApiKeyPagingResultModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
